import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Selector } from "@/model";
import selectorRepository from "@/repository/selectorRepository";
import { selectorQueryKeys } from "./keys";


interface DeleteSelectorParams {
    ids?: string[];
    keyword?: string;
}

export const useDeleteSelector = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Selector, AxiosError, DeleteSelectorParams>({
        mutationKey: ["selector", "agent", agentId, "delete"],
        mutationFn: async (params) => {
            try {
                const res = await selectorRepository.deleteMany(agentId, params.ids, params.keyword);
                return res.data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: selectorQueryKeys.pageAll(agentId),
                exact: false
            });
        }
    });
};
